import React, { useState, useRef, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Form from "react-validation/build/form";
import DatePicker from "react-datepicker";
import ContentLoader from "react-content-loader";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import CheckButton from "react-validation/build/button";

import { getTrans as t } from "../../../../Localization/translations";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import Helper from "../../../../Helper";
import EditPartyService from "../../../../services/party/editParty.service";
import ACHproviderService from "../../../../services/ACHproviders/ACHproviderServices";
import { EXEMPTION_STATUS_OPTIONS } from "../../exemptionStatus";

function PartyEdit({
  partyType,
  setNotesLength,
  setEmail_invoice_notification_count,
  email_invoice_notification_count,
}) {
  const [establishment_date, setEstablishment] = useState(null);
  const [party_type, setParty_type] = useState([]);
  const [customer_type, setCustomer_type] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [sales_tax_code, setSales_tax_code] = useState("");
  const [TIN_number, setTIN_number] = useState("");
  const [website, setWebsite] = useState("");
  const [prefix, setPrefix] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [middle_name, setMiddle_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [ssn_tin_number, setSsn_tin_number] = useState("");
  const [id_number, setId_number] = useState("");
  const [id_issue_state, setId_issue_state] = useState("");
  const [date_of_birth, setDate_of_birth] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [doingbusinessas, setDoingBusinessAs] = useState("");
  const [business_type, setBusinessType] = useState("");
  const [federalID, setFederalID] = useState("");
  const [sic, setSIC] = useState("");
  const [naics, setNAICS] = useState("");
  const [riskrating, setRiskRating] = useState("");
  const [creditscore, setCreditScore] = useState("");
  const [achPayments, setAchPayments] = useState(false);
  // const [email, setEmail] = useState("")
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [showhide, setShowHide] = useState("");
  const [extrafiledparty, setExtraFiled] = useState([]);
  const [successful, setSuccessful] = useState(false);
  const [disable, setDisable] = useState(false);

  const [pre_bill_days, setpre_bill_days] = useState(null);
  const [consolidate_invoice, setConsolidate_invoice] = useState(null);
  const [generate_Invoice, setGenerate_Invoice] = useState(null);
  const [exemption_status, setExemptionStatus] = useState("");

  const isCustomer = party_type.includes('Customer');

  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm();
  const form = useRef();
  let navigate = useNavigate();
  const { state } = useLocation();

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };

  const getExtrafiled = () => {
    setIsLoading(true);
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existparty);
      // setTimeout(() => {
      setIsLoading(false);
      // }, 1000);
    });
  };

  useEffect(() => {
    getExtrafiled();
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...attribute];
    rowsInput[index][name] = value;
    setAttribute(rowsInput);
  };

  const [showACHPayments, setShowACHPayments] = useState(false);
  const Achprovider = () => {
    try {
      ACHproviderService.viewACHprovider().then((response) => {
        const achProviderCount = response.data.total;
        setShowACHPayments(achProviderCount === 1);
      });
    } catch (error) {
      console.error("Error fetching ACH providers:", error);
      setShowACHPayments(false);
    }
  };

  useEffect(() => {
    Achprovider();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    EditPartyService.getParty(state).then((response) => {
      setParty_type(response.data.party_type.split(", "));
      setCustomer_type(response.data.customer_type);
      setCustomer_name(response.data.customer_name);
      setSales_tax_code(response.data.sales_tax_code);
      setTIN_number(response.data.TIN_number);
      setWebsite(response.data.website);
      setPrefix(response.data.prefix);
      setFirst_name(response.data.first_name);
      setMiddle_name(response.data.middle_name);
      setLast_name(response.data.last_name);
      setSsn_tin_number(response.data.ssn_tin_number);
      setId_number(response.data.id_number);
      setId_issue_state(response.data.id_issue_state);
      setDate_of_birth(response.data.date_of_birth);
      setEstablishment(response.data.establishment_date);
      setShowHide(response.data.customer_type);
      setNotesLength(response.data.has_notes);
      setpre_bill_days(response.data.pre_bill_days);
      setGenerate_Invoice(response.data.generate_invoice);
      setExemptionStatus(response.data.exemption_status || "");
      setConsolidate_invoice(response.data.consolidate_invoice);
      setEmail_invoice_notification_count(
        response.data.email_invoice_notification_count
      );
      setDoingBusinessAs(response.data.doingBusinessAs);
      setBusinessType(response.data.business_type);
      setFederalID(response.data.federalID);
      setSIC(response.data.SIC);
      setNAICS(response.data.NAICS);
      setRiskRating(response.data.riskrating);
      setCreditScore(response.data.creditscore);
      setAchPayments(response.data.ACHPayments);

      setAttribute([
        { attribute: response.data.attribute1 },
        { attribute: response.data.attribute2 },
        { attribute: response.data.attribute3 },
        { attribute: response.data.attribute4 },
        { attribute: response.data.attribute5 },
        { attribute: response.data.attribute6 },
        { attribute: response.data.attribute7 },
        { attribute: response.data.attribute8 },
        { attribute: response.data.attribute9 },
        { attribute: response.data.attribute10 },
        { attribute: response.data.attribute11 },
        { attribute: response.data.attribute12 },
        { attribute: response.data.attribute13 },
        { attribute: response.data.attribute14 },
        { attribute: response.data.attribute15 },
      ]);
      // setTimeout(() => {
      // }, 1000);

      reset({
        party_type: response.data.party_type,
        customer_name: response.data.customer_name,
        customer_type: response.data.customer_type,
      });
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    partyType(party_type);
  }, [party_type]);

  const handleDate = (date) => {
    setEstablishment(date);
  };

  const handleCheckboxChange = (e) => {
    setAchPayments(e.target.checked);
  };

  const handleRegister = (id) => {
    setSuccessful(false);
    setDisable(true);
    form.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    let generate_invoice = generate_Invoice;

    if (checkBtn.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      EditPartyService.editParty(
        state,
        party_type.join(", "),
        customer_type,
        customer_name,
        establishmentDate,
        TIN_number,
        sales_tax_code,
        website,
        prefix,
        first_name,
        middle_name,
        last_name,
        ssn_tin_number,
        id_number,
        id_issue_state,
        dateofbirth,
        attribute,
        consolidate_invoice,
        pre_bill_days !== "" ? pre_bill_days : null,
        generate_invoice,
        doingbusinessas,
        business_type,
        federalID,
        sic,
        naics,
        riskrating,
        creditscore,
        achPayments,
        exemption_status
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setTimeout(() => {
            navigate("/party");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setDisable(false);
        }
      });
    }
  };
  const handlePartyCheckbox = (e) => {
    const { value } = e.target;
    const updatedValues = [...party_type];

    if (e.target.checked) {
      updatedValues.push(value);
    } else {
      const index = updatedValues.indexOf(value);
      if (index > -1) {
        updatedValues.splice(index, 1);
      }
    }

    setParty_type(updatedValues);
  };

  const handleConsolidateInvoice = (e) => {
    setConsolidate_invoice(e.target.value);
    // setShowHide(getuser);
  };

  const handleGenerateInvoice = (e) => {
    setGenerate_Invoice(e.target.value);
    // setShowHide(getuser);
  };

  return (
    <>
      <div className="container-fluid">
        <ToastContainer />
        <h5>{t("Party Edit")}</h5>
        <div className="card" role="document">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                {isLoading !== true ? (
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyForm"
                  >
                    {
                      <>
                        <div className=" row">
                          <div className="col-md-7">
                            <label className="col-form-label required">
                              {t("Party Type")}{" "}
                              <Tooltip content={t("PartyType_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="form-group row">
                              <div
                                className="form-check"
                                style={{ width: "25%", paddingLeft: "2.73em" }}
                              >
                                <input
                                  className="form-check-input"
                                  value="Customer"
                                  type="checkbox"
                                  name="Customer"
                                  checked={party_type.includes("Customer")}
                                  id="flexRadioDefault1"
                                  {...register("party_type", {
                                    onChange: (e) => {
                                      handlePartyCheckbox(e);
                                    },
                                    required: true,
                                  })}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                >
                                  Customer
                                </label>
                              </div>
                              <div
                                className="form-check"
                                style={{ width: "25%", paddingLeft: "3.0em" }}
                              >
                                <input
                                  className="form-check-input"
                                  value="Vendor"
                                  type="checkbox"
                                  name="Vendor"
                                  id="flexRadioDefault2"
                                  checked={party_type.includes("Vendor")}
                                  {...register("party_type", {
                                    onChange: (e) => {
                                      handlePartyCheckbox(e);
                                    },
                                    required: true,
                                  })}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault2"
                                >
                                  Vendor
                                </label>
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {errors.party_type?.type === "required" &&
                                "Party Type  is required"}
                            </div>
                          </div>

                          <div className="mb-1">
                            <label className="col-form-label required">
                              {t("Entity Type")}{" "}
                              <Tooltip content={t("EntityType_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <div className="form-group row">
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    value="Person"
                                    type="radio"
                                    name="customer_type"
                                    id="id_customer_type"
                                    {...register("customer_type", {
                                      onChange: (e) => {
                                        handleshowhide(e);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault5"
                                  >
                                    Person
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    value="Organization"
                                    type="radio"
                                    name="customer_type"
                                    id="id_customer_type"
                                    {...register("customer_type", {
                                      onChange: (e) => {
                                        handleshowhide(e);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault6"
                                  >
                                    Organization
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {errors.customer_type?.type === "required" &&
                                "Entity Type  is required"}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-3">
                            <label className="col-form-label required">
                              {t("Party Name")}{" "}
                              <Tooltip content={t("PartyName_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Party Name")}
                              className="form-control"
                              type="text"
                              value={customer_name}
                              name="customer_name"
                              maxLength="200"
                              id="id_customer_name"
                              {...register("customer_name", {
                                onChange: (e) => {
                                  setCustomer_name(e.target.value);
                                },
                                required: true,
                              })}
                            />
                          </div>
                          <div className="invalid-feedback">
                            {errors.customer_name?.type === "required" &&
                              "Party Name  is required"}
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-sm-3">
                            <label className="col-form-label">
                              {t("Establishment Date")}{" "}
                              <Tooltip content={t("EstablishmentDate_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <DatePicker
                              className="form-control datepick"
                              selected={
                                establishment_date
                                  ? new Date(establishment_date)
                                  : ""
                              }
                              onChange={handleDate}
                              placeholderText={"mm/dd/yyyy"}
                              dateFormat="P"
                              scrollableYearDropdown
                              showMonthDropdown
                              showYearDropdown
                              scrollableMonthYearDropdown
                              maxDate={new Date()}
                              dropdownMode="select"
                            />
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">
                              {t("Tax Number")}{" "}
                              <Tooltip content={t("TaxNumber_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Tax Number")}
                              className="form-control"
                              type="text"
                              value={TIN_number}
                              onChange={(e) => setTIN_number(e.target.value)}
                              name="TIN_number"
                              maxLength="100"
                              id="id_TIN_number"
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <div className="col-sm-3">
                            <label className="col-form-label">
                              {t("Sales Tax Code")}{" "}
                              <Tooltip content={t("SalesTaxCode_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Sales Tax Code")}
                              className="form-control"
                              type="text"
                              value={sales_tax_code}
                              onChange={(e) =>
                                setSales_tax_code(e.target.value)
                              }
                              name="sales_tax_code"
                              maxLength="100"
                              id="id_sales_tax_code"
                            />
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">
                              {t("Website")}{" "}
                              <Tooltip content={t("Website_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Website URL")}
                              className="form-control"
                              type="text"
                              value={website}
                              onChange={(e) => setWebsite(e.target.value)}
                              name="website"
                              maxLength="100"
                              id="id_website"
                            />
                          </div>
                        </div>

                        {showhide === "Person" && (
                          <div className="form-group row">
                            {/* <div className="col-sm-3">
                            <label className="col-form-label">{t('Prefix')} <Tooltip content={t('Prefix_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <select
                              value={prefix}
                              className="form-control form-select"
                              name="prefix"
                              onChange={(e) => setPrefix(e.target.value)}
                              id="id_prefix"
                            >
                              <option value="" >
                                {t('Select Prefix')}
                              </option>
                              <option value="Mr">{t('Mr')}</option>
                              <option value="Mrs">{t('Mrs')}</option>
                              <option value="Ms">{t('Ms')}</option>
                            </select>
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">{t('First Name')} <Tooltip content={t('FirstName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              placeholder={t('First Name')}
                              className="form-control"
                              type="text"
                              value={first_name}
                              onChange={(e) => setFirst_name(e.target.value)}
                              name="first_name"
                              maxLength="100"
                              id="id_first_name" 
                            />
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">{t('Middle Name')} <Tooltip content={t('MiddleName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              placeholder={t('Middle Name')}
                              className="form-control"
                              type="text"
                              value={middle_name}
                              onChange={(e) => setMiddle_name(e.target.value)}
                              name="middle_name"
                              maxLength="100"
                              id="id_middle_name" 
                            />
                          </div>

                          <div className="col-sm-3">
                            <label className="col-lg-12 col-form-label">{t('last')} {t('name')} <Tooltip content={t('LastName_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              placeholder={t('Last Name')}
                              className=" form-control"
                              type="text"
                              value={last_name}
                              onChange={(e) => setLast_name(e.target.value)}
                              name="last_name"
                              maxLength="100"
                              id="id_last_name"
                            />
                          </div> */}

                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("SSN / TIN Number")}{" "}
                                <Tooltip content={t("SSN/TINNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                {...register("ssn_tin_number", {
                                  required: false,
                                })}
                                placeholder={t("SSN / TIN Number")}
                                className="form-control"
                                type="text"
                                value={ssn_tin_number}
                                onChange={(e) =>
                                  setSsn_tin_number(e.target.value)
                                }
                                name="ssn_tin_number"
                                maxLength="100"
                                id="id_ssn_tin_number"
                              />
                            </div>

                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("ID Number")}{" "}
                                <Tooltip content={t("IDNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("ID Number")}
                                className="form-control"
                                type="text"
                                value={id_number}
                                onChange={(e) => setId_number(e.target.value)}
                                name="id_number"
                                maxLength="100"
                                id="id_id_number"
                              />
                            </div>

                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("ID Issue State")}{" "}
                                <Tooltip content={t("IdIssueState_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("ID Issue State")}
                                className="form-control"
                                type="text"
                                value={id_issue_state}
                                onChange={(e) =>
                                  setId_issue_state(e.target.value)
                                }
                                name="id_issue_state"
                                maxLength="30"
                                id="id_id_issue_state"
                              />
                            </div>

                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("Date of Birth")}{" "}
                                <Tooltip content={t("DateofBirth_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <DatePicker
                                className="form-control datepick"
                                selected={
                                  date_of_birth ? new Date(date_of_birth) : ""
                                }
                                onChange={(e) => setDate_of_birth(e)}
                                scrollableYearDropdown
                                showMonthDropdown
                                showYearDropdown
                                scrollableMonthYearDropdown
                                maxDate={new Date()}
                                placeholderText={"mm/dd/yyyy"}
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        )}
                        <div className="row">
                          {isCustomer && (
                            <div className="col-md-3">
                              <label className="col-form-label">
                                {t("Pre bill days")}{" "}
                                <Tooltip content={t("Pre_billdays_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Pre bill days")}
                                className="form-control no-spinner"
                                type="number"
                                name="pre_bill_days"
                                maxLength="200"
                                id="id_pre_bill_days"
                                value={pre_bill_days}
                                {...register("pre_bill_days", {
                                  onChange: (e) => {
                                    const value = e.target.value;
                                    if (value < 0) {
                                      setError("pre_bill_days", {
                                        type: "validate",
                                        message: "Value cannot be less than 0",
                                      });
                                    } else {
                                      clearErrors("pre_bill_days");
                                    }

                                    setpre_bill_days(value);
                                  },
                                  required: false,
                                  // validate: (value) => value >= 0 || "Value cannot be less than 0"
                                })}
                              />
                              <div className="invalid-feedback">
                                {/* {errors.pre_bill_days?.type === 'required' && "Pre bill days is required"} */}
                                {errors.pre_bill_days?.message}
                              </div>
                            </div>
                          )}

                          <div className="col-md-3">
                            <label className="col-form-label ">
                              {t("Doing Business As")}{" "}
                              <Tooltip content={t("DoingBusinessAs_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              placeholder={t("Doing Business As")}
                              className="form-control"
                              type="text"
                              name="DoingBusinessAs"
                              // maxLength="30"
                              id="id_zip_code"
                              value={doingbusinessas}
                              {...register("DoingBusinessAs", {
                                onChange: (e) => {
                                  setDoingBusinessAs(e.target.value);
                                },
                                required: false,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.DoingBusinessAs?.type === "required" &&
                                "Doing Business As is required"}
                            </div>
                          </div>
                          {showhide === "Organization" &&
                            (<>

                              <div className="col-md-3">
                                <label className="col-form-label ">
                                  {t("Business Type")}{" "}
                                  <Tooltip content={t("Business_Type_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Business Type")}
                                  className="form-control"
                                  type="text"
                                  name="Business_Type"
                                  // maxLength="30"
                                  id="id_Business_Type"
                                  value={business_type}
                                  {...register("Business_Type", {
                                    onChange: (e) => {
                                      setBusinessType(e.target.value);
                                    },
                                    required: false,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.Business_Type?.type === "required" &&
                                    "Business Type  is required"}
                                </div>
                              </div>
                              <div className="col-md-3">
                                <label className="col-form-label ">
                                  {t("Federal ID")}{" "}
                                  <Tooltip content={t("FederalID_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Federal ID")}
                                  className="form-control"
                                  type="text"
                                  name="FederalID"
                                  // maxLength="30"
                                  id="id_FederalID"
                                  value={federalID}
                                  {...register("FederalID", {
                                    onChange: (e) => {
                                      setFederalID(e.target.value);
                                    },
                                    required: false,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.FederalID?.type === "required" &&
                                    "Federal ID  is required"}
                                </div>
                              </div>
                              <div className="col-md-3">
                                <label className="col-form-label ">
                                  {t("SIC")}{" "}
                                  <Tooltip content={t("SIC_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("SIC")}
                                  className="form-control"
                                  type="text"
                                  name="SIC"
                                  // maxLength="30"
                                  id="id_SIC"
                                  value={sic}
                                  {...register("SIC", {
                                    onChange: (e) => {
                                      setSIC(e.target.value);
                                    },
                                    required: false,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.SIC?.type === "required" &&
                                    "SIC  is required"}
                                </div>
                              </div>
                              <div className="col-md-3">
                                <label className="col-form-label ">
                                  {t("NAICS")}{" "}
                                  <Tooltip content={t("NAICS_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("NAICS")}
                                  className="form-control"
                                  type="text"
                                  name="NAICS"
                                  // maxLength="30"
                                  id="id_SIC"
                                  value={naics}
                                  {...register("NAICS", {
                                    onChange: (e) => {
                                      setNAICS(e.target.value);
                                    },
                                    required: false,
                                  })}
                                />
                                <div className="invalid-feedback">
                                  {errors.NAICS?.type === "required" &&
                                    "NAICS  is required"}
                                </div>
                              </div>
                            </>)}
                          {showhide === 'Person' && (<>
                            <div className="col-md-3">
                              <label className="col-form-label ">
                                {t("Risk Rating")}{" "}
                                <Tooltip content={t("RiskRating_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Risk Rating")}
                                className="form-control"
                                type="text"
                                name="RiskRating"
                                // maxLength="30"
                                id="id_RiskRating"
                                value={riskrating}
                                {...register("RiskRating", {
                                  onChange: (e) => {
                                    setRiskRating(e.target.value);
                                  },
                                  required: false,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.RiskRating?.type === "required" &&
                                  "RiskRating  is required"}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <label className="col-form-label ">
                                {t("Credit Score")}{" "}
                                <Tooltip content={t("CreditScore_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("Credit Score")}
                                className="form-control"
                                type="text"
                                name="CreditScore"
                                // maxLength="30"
                                id="id_CreditScore"
                                value={creditscore}
                                {...register("CreditScore", {
                                  onChange: (e) => {
                                    setCreditScore(e.target.value);
                                  },
                                  required: false,
                                })}
                              />
                              <div className="invalid-feedback">
                                {errors.CreditScore?.type === "required" &&
                                  "CreditScore  is required"}
                              </div>
                            </div>
                          </>)}
                          {/* <div className="col-md-6"> */}
                          {/* <label className="col-form-label">
                              {t("Consolidate Invoice")}{" "}
                              <Tooltip content={t("Consolidate invoice_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label> */}
                          {/* <div className="form-group row">
                              <div className="col-md-3">
                                <div
                                  className="form-check"
                                >
                                  <input
                                    className="form-check-input"
                                    value="Yes"
                                    type="radio"
                                    name="consolidate_invoice"
                                    checked={consolidate_invoice === "Yes"}
                                    id="id_consolidate_invoice"
                                    {...register("consolidate_invoice", {
                                      onChange: (e) => {
                                        handleConsolidateInvoice(e);
                                      },
                                      required: true,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    Yes
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    value="No"
                                    checked={consolidate_invoice === "No"}
                                    type="radio"
                                    name="consolidate_invoice"
                                    id="id_consolidate_invoice"
                                    {...register("consolidate_invoice", {
                                      onChange: (e) => {
                                        handleConsolidateInvoice(e);
                                      },
                                      required: false,
                                    })}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div> */}

                          {/* <div className="invalid-feedback">
                            {errors.consolidate_invoice?.type === "required" &&
                              "Consolidate Invoice is required"}
                          </div> */}
                          {/* </div> */}
                          {isCustomer && (
<div className="col-md-6">
                              <label className="col-form-label">Exemption Status</label>
                              <select
                                className="form-control form-select"
                                name="exemption_status"
                                id="id_exemption_status"
                                value={exemption_status || ""}
                                onChange={(e) => setExemptionStatus(e.target.value)}
                              >
                                <option value="">None (taxable)</option>
                                {EXEMPTION_STATUS_OPTIONS.map((o) => (
                                  <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                              </select>
                            </div>
                          )}
                          {isCustomer && (
                            <div className="col-md-6">
                              <label className="col-form-label">
                                {t("Generate Invoice")}{" "}
                                <Tooltip content={t("Generate_invoice_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="form-group row">
                                <div className="col-12 col-md-6">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      value="Yes"
                                      type="radio"
                                      name="generate_invoice"
                                      checked={generate_Invoice === "Yes"}
                                      id="id_generate_invoice"
                                      disabled={
                                        email_invoice_notification_count !== 0
                                      }
                                      {...register("generate_invoice", {
                                        onChange: (e) => {
                                          handleGenerateInvoice(e);
                                        },
                                        required: false,
                                      })}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioDefault1"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      value="No"
                                      checked={generate_Invoice === "No"}
                                      type="radio"
                                      name="generate_invoice"
                                      id="id_generate_invoice"
                                      disabled={
                                        email_invoice_notification_count !== 0
                                      }
                                      {...register("generate_invoice", {
                                        onChange: (e) => {
                                          handleGenerateInvoice(e);
                                        },
                                        required: false,
                                      })}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexRadioDefault1"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                              </div>

                              {/* <div className="invalid-feedback">
                            {errors.generate_invoice?.type === "required" &&
                              "Generate Invoice is required"}
                          </div> */}
                            </div>
                          )}
                          {isCustomer && showACHPayments == true && (
                            <div className="col-md-6">
                              <div
                                className="form-check"
                                style={{
                                  width: "100%",
                                  paddingLeft: "2.73em",
                                  paddingTop: "2.3em",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="achPayments"
                                  checked={achPayments}
                                  onChange={handleCheckboxChange}
                                  className="form-check-input"
                                />
                                <label
                                  htmlFor="achPayments"
                                  className="form-check-label tc  font-weight-bold"
                                >
                                  {t("ACH Payments")}{" "}
                                  <Tooltip content={t("Ach_Payments_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                        {/* {generate_Invoice === "Yes" &&
                          <div className="col-md-3">
                            <label className="col-form-label">{t('Email')} <Tooltip content={t("Email_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <input
                              placeholder={t('Email')}
                              className="form-control no-spinner"
                              type="text"
                              name="email"
                              id="email"
                              value={email}
                              {...register("email", {
                                onChange: (e) => {
                                  const value = e.target.value;
                                  setEmail(value)
                                }, required: false,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.email?.message}
                            </div>
                          </div>
                        } */}
                        {extrafiledparty.length === 0 ? (
                          ""
                        ) : (
                          <h4 className="tc mt-4">
                            {t("Additional Information")} :
                          </h4>
                        )}
                        <div className="form-group row">
                          {extrafiledparty.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-3" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  id={"attribute_" + index}
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  value={
                                    attribute[index]["attribute"]
                                      ? attribute[index]["attribute"]
                                      : ""
                                  }
                                  className="form-control mb-1"
                                  name="attribute"
                                  type={key.datatype}
                                  placeholder={key.label}
                                  onChange={(e) =>
                                    onChangeextrafileds(e, index)
                                  }
                                />
                              </>
                            </div>
                          ))}
                        </div>
                        <div className="text-left  py-4 ">
                          <Link to={"/party"}>
                            <button
                              type="button"
                              className="btn btn-secondary btn-md"
                            >
                              {t("Cancel")}
                            </button>
                            &nbsp;
                          </Link>
                          <button
                            type="submit"
                            disabled={disable}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {t("Save")}
                          </button>
                          &nbsp;
                        </div>
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form>
                ) : (
                  <ContentLoader
                    viewBox="0 0 1000 550"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                  >
                    <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                    <circle cx="879" cy="123" r="11" />
                    <circle cx="914" cy="123" r="11" />
                    <rect
                      x="104"
                      y="115"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="305"
                      y="114"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="661"
                      y="114"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                    <circle cx="880" cy="184" r="11" />
                    <circle cx="915" cy="184" r="11" />
                    <rect
                      x="105"
                      y="176"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="306"
                      y="175"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="662"
                      y="175"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="242" r="11" />
                    <circle cx="916" cy="242" r="11" />
                    <rect
                      x="106"
                      y="234"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="307"
                      y="233"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="663"
                      y="233"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="303" r="11" />
                    <circle cx="917" cy="303" r="11" />
                    <rect
                      x="107"
                      y="295"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="294"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="294"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="363" r="11" />
                    <circle cx="916" cy="363" r="11" />
                    <rect
                      x="106"
                      y="355"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="307"
                      y="354"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="663"
                      y="354"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="424" r="11" />
                    <circle cx="917" cy="424" r="11" />
                    <rect
                      x="107"
                      y="416"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="415"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="415"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                    <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                    <circle cx="882" cy="484" r="11" />
                    <circle cx="917" cy="484" r="11" />
                    <rect
                      x="107"
                      y="476"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect
                      x="308"
                      y="475"
                      rx="3"
                      ry="3"
                      width="299"
                      height="15"
                    />
                    <rect
                      x="664"
                      y="475"
                      rx="3"
                      ry="3"
                      width="141"
                      height="15"
                    />
                    <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                    <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                    <rect
                      x="222"
                      y="54"
                      rx="3"
                      ry="3"
                      width="149"
                      height="33"
                    />
                    <rect
                      x="544"
                      y="55"
                      rx="3"
                      ry="3"
                      width="137"
                      height="33"
                    />
                    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                  </ContentLoader>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartyEdit;
